import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { ListGroup, ListGroupItem, OverlayTrigger, Popover } from 'react-bootstrap';
import Masonry from 'react-masonry-component';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faExclamationCircle from '@fortawesome/fontawesome-free-solid/faExclamationCircle'
import faEllipsisH from '@fortawesome/fontawesome-free-solid/faEllipsisH'
import faThumbsUp from '@fortawesome/fontawesome-free-solid/faThumbsUp'
import { Message } from '../Message';
import { AlertsService, AlertStatusesService, DeviceDataOverrideService } from '../../services';
import MonitoringDeviceTable from './monitoring_device_table'
import { EntityDetailModal } from '../Entity';
import withSizes from 'react-sizes'
import { DataTypeDisplayValue } from '../DataTypeDisplayValue';
import i18next from "i18next";
import config from "config";

@withSizes(({ width }) => ({ isMobile: width < 455 }))

class MonitoringAlerts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      localErrorMessage: null,
      localSuccessMessage: null,
      alertsByArea: null,
      linkTo: null,
      alert: null,
      filterOptions: null,
      entities : this.props.entities,
      gridSelected: true,
      showEntityDetailModal: false
    };

    this.MASONRY_OPTIONS = {
      itemSelector: '.masonry-item',
      transitionDuration: 0,
      percentPosition: true,
      columnWidth: '.masonry-sizer',
      gutter: '.gutter-sizer',
      stagger: 30
    };

    this.toggleEntityDetailModal = this.toggleEntityDetailModal.bind(this);
    this.handleLocalError = this.handleLocalError.bind(this);
    this.handleLocalSuccess = this.handleLocalSuccess.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  toggleEntityDetailModal(entitySerialNumber, area, alertCount = 0) {
    this.setState({
      alertCount: alertCount,
      detailArea: area,
      entitySerialNumber: entitySerialNumber,
      showEntityDetailModal: !this.state.showEntityDetailModal
    });
  }

  componentDidMount() {
    AlertStatusesService.listAll().then(response => {
      this.setState({filterOptions: response.alertStatuses.map(status =>
        {return {value: status.id, id: status.id, label: i18next.t(`alert-statuses.${status.token}`), token: status.token, description: status.description}})})
    })
    this.refresh();
  }

  refresh() {
    AlertsService.alertsByArea(this.props.grouping.id, true).then(response => {
      for (let i = 0; i < response.alertsByArea.length; i++) {
        response.alertsByArea[i].entities = this.state.entities.filter(device => {
          return response.alertsByArea[i].tag.id === device.areaTag?.id;
        });
      }
      this.setState( { alertsByArea: response.alertsByArea, gridSelected: response.alertsByArea.filter(area => area.alerts.length == 0).length > 0 });
    }).catch(error => {
      console.error(error);
      this.handleLocalError(error.message);
    });
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null, localSuccessMessage: null });
  }

  renderMessages() {
    return this.state.localErrorMessage || this.state.localSuccessMessage
      ? (<Message  messages={{ state: { successMessage: this.state.localSuccessMessage } }} errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />)
      : (null);
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleLocalSuccess(localSuccessMessage) {
    this.setState({ localSuccessMessage: localSuccessMessage });
  }

  handleViewDetails(groupingId, alertId) {
    this.setState({ linkTo: `/monitoring/locations/${groupingId}/events/${alertId}` });
  }

  handleViewTickets(ticketId) {
    this.setState({ linkTo: `/monitoring/tickets/view/${ticketId}`});
  }

  updateStatus(newStatus, alertId) {
    this.setState({updatingStatus: true})
    AlertsService.updateStatus(alertId, newStatus).then(_ => {
      this.setState({updatingStatus: false})
      this.refresh();
      this.handleLocalSuccess(i18next.t('messages.update-event-status-success'))
    }).catch(_ => {
      this.setState({updatingStatus: false})
      this.handleLocalError(i18next.t('messages.update-event-status-failure'))
    })
  }

  linkToHistory() {
    this.setState({linkToAlertHistory: true})
  }

  gridSelected() {
    this.setState({gridSelected: true})
  }

  listSelected() {
    this.setState({gridSelected: false})
  }

  getPrimaryMeasurements(entity, area, unresolvedAlert) {
    let exceededByDeviceTypeTokens = {};
    let exceededByDeviceClassTokens = {};

    for (let i = 0; i < entity.thresholdsExceeded.length; i++) {
      let curExceeded = entity.thresholdsExceeded[i]
      for (let j = 0; j < curExceeded.tags.length; j++) {
        if (curExceeded.tags[j].id = area.tag.id) {
          if (curExceeded.deviceDataType) exceededByDeviceTypeTokens[curExceeded.deviceDataType.token] = true;
          if (curExceeded.deviceDataClassification) exceededByDeviceClassTokens[curExceeded.deviceDataClassification.token] = true;
        }
      }
    }

    const sortFn = (a, b) => (
      (a.lastReceivedData.deviceDataType.displayOrder - b.lastReceivedData.deviceDataType.displayOrder) ||
      a.originatingMeasureName.localeCompare(b.originatingMeasureName)
    );

    // Add data is primary when the entity is an asset
    let primaryData = entity.entityTypeToken == 'asset' ?  
                      entity.currentMeasurements
                          .filter(data => !data.endTime)
                          .filter(data => data.lastReceivedData != null && data.lastReceivedData.deviceDataType.primary)
                          .sort(sortFn)
                      :
                      entity.currentMeasurements
                          .filter(data => data.lastReceivedData != null && data.lastReceivedData.deviceDataType.primary)
                          .sort(sortFn);

    // If there are no primary data points then fall back to all others
    if (primaryData.length == 0) {
      primaryData = entity.entityTypeToken == 'asset' ?  
                    entity.currentMeasurements
                        .filter(data => !data.endTime)
                        .filter(data => data.lastReceivedData != null)
                        .sort(sortFn)
                    :
                    entity.currentMeasurements
                        .filter(data => data.lastReceivedData != null)
                        .sort(sortFn);
    }

    if (primaryData.length == 0) {
      return (
        <div className='device-measurements' key={`${entity.entityId}`}>
          <div className={`reading`}>
            <div className='measurement-line'>
              No Data
            </div>
          </div>
        </div>
      );
    }

    return primaryData.map(ad => {      
      let data = ad.lastReceivedData;
      if (data?.numericValue != null) {
          data = { ...data, numericValue: DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(ad.lastReceivedData.token)(data.numericValue) };
      }
      var exceeded = false;
      if (ad.originatingDeviceDataTypeToken) {
        if (ad.originatingDeviceDataTypeToken == "online" && !ad.online) {
            exceeded = true;
        }
        if (exceededByDeviceTypeTokens[ad.originatingDeviceDataTypeToken] || exceededByDeviceClassTokens[ad.originatingDeviceDataClassificationToken]) {
          exceeded = true;
        }
      }

      return (
        <div className='device-measurements' key={`${entity.entityId}_${ad.originatingDeviceSerialNumber}_${data.deviceDataType.id}`}>
          <div className={`reading ${exceeded && unresolvedAlert ? "reading-bold" : ''}`}>
            <div className='measurement-line'>
              <DataTypeDisplayValue value={data} measureName={entity.entityTypeToken == 'asset' && ad.originatingMeasureName} deviceTypeToken={entity.originatingDeviceDataTypeToken} displayLabel={true} />
              <div className={`dot dot--${exceeded ? "failure" : "success"} dot--small alert-dot`} />
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const areasNeededAttention = this.state.alertsByArea && this.state.alertsByArea.filter(area => area.alerts.length > 0);
    const areasFullyOperational = this.state.alertsByArea && this.state.alertsByArea.filter((area) => area.alerts.length === 0);

    if (this.state.linkTo) {
      return <Redirect push to={{
        pathname: this.state.linkTo,
        state: {
          history: "/monitoring/locations",
          grouping: this.props.grouping
        }
      }} />;
    }

    if(this.state.linkToAlertHistory) {
      return <Redirect push to={{
        pathname: `/monitoring/locations/${this.props.grouping.id}/events`,
        state: {
          grouping: this.props.grouping
        }
      }} />;
    }

    if (this.state.alertsByArea && !this.state.updatingStatus && this.state.filterOptions) {
      return (
        <div className ="monitoring-alerts">
          {this.renderMessages()}
          <div className={!this.props.isMobile ? "l-region needing-attention-region" : "l-region"}>
            <div className="l-region__heading">
              <div className="header-icon">
                <img src={`${config.WEB_BASE_URL}/images/icon/exclamation_devicegrid.svg`} className="icon icon--medium top-icon" />
                <h2 className = {this.props.isMobile ? "header-mobile" : undefined}>{ i18next.t('messages.unresolved-events-areas') }</h2>
              </div>
              {/* <button onClick = {this.linkToHistory.bind(this)} className="btn btn-sm btn-default">Alert History</button> */}
            </div>
            <div className="l-region__content">
              {
                areasNeededAttention && areasNeededAttention.length > 0 ? (
                  <Masonry options={this.MASONRY_OPTIONS}>
                    <div className="masonry-sizer" />
                    <div className="gutter-sizer" />
                    {areasNeededAttention.map((area, index) => (
                      <div className="masonry-item" key={index}>
                        <AreaWithAlerts
                          area={area}
                          key={index}
                          index={index}
                          grouping={this.props.grouping}
                          timezone={this.props.grouping.timezone}
                          filterOptions={this.state.filterOptions}
                          handleViewDetails={this.handleViewDetails.bind(this)}
                          handleViewTickets={this.handleViewTickets.bind(this)}
                          updateStatus={this.updateStatus.bind(this)}
                          deviceClicked = {this.toggleEntityDetailModal}
                          getPrimaryMeasurements = {this.getPrimaryMeasurements.bind(this)}
                        />
                      </div>
                    ))}
                  </Masonry>
                ) : <div>
                  {this.props.isMobile ?
                    <div className="wrap wrap-mobile">
                      <div><FontAwesomeIcon icon={faThumbsUp}/> { i18next.t('messages.no-unresolved-reports-1') } { i18next.t('messages.no-unresolved-reports-2') }</div>
                    </div> :
                    <div className="wrap">
                      <div><FontAwesomeIcon icon={faThumbsUp}/> { i18next.t('messages.no-unresolved-reports-1') }</div>
                      <div>{ i18next.t('messages.no-unresolved-reports-2') }</div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          {
            areasFullyOperational ? (
              <div>
                <div className="l-region__heading">
                  <div className="header-icon bottom-header">
                    {/* <img src={`${config.WEB_BASE_URL}/images/icon/green_check_devicegrid.svg`} className="top-icon icon icon--medium" /> */}
                    {this.state.gridSelected ?
                      <h2 className={this.props.isMobile ? "header-mobile" : undefined}>{ i18next.t('pages.devices.asset-grid') }</h2> :
                      <h2 className={this.props.isMobile ? "header-mobile" : undefined}>{ i18next.t('pages.devices.asset-list') }</h2>
                    }
                    <div className = "pull-right">
                      <div className="tooltip">
                        {this.state.gridSelected ? <img src={`${config.WEB_BASE_URL}/images/icon/grid_icon.svg`} onClick = {this.gridSelected.bind(this)} className="top-icon icon icon--xlarge view-icon" /> : <img src={`${config.WEB_BASE_URL}/images/icon/grid_icon_unselected.svg`} onClick = {this.gridSelected.bind(this)} className="top-icon icon icon--xlarge view-icon" />}
                        <span className={`tooltiptext${this.props.isMobile ? ' tooltiptext-mobile grid-mobile' : ' gridtip'}`}>{ i18next.t('pages.devices.grid-view') }</span>
                      </div>
                      <div className="tooltip">
                        {this.state.gridSelected ? <img src={`${config.WEB_BASE_URL}/images/icon/listing_icon.svg`} onClick = {this.listSelected.bind(this)}  className="top-icon icon icon--xlarge right-icon view-icon" /> : <img src={`${config.WEB_BASE_URL}/images/icon/listing_icon_selected.svg`} onClick = {this.listSelected.bind(this)}  className="top-icon icon icon--xlarge right-icon view-icon" />}
                        <span className={`tooltiptext${this.props.isMobile ? ' tooltiptext-mobile' : ''}`}>{ i18next.t('pages.devices.list-view') }</span>
                      </div>
                    </div>
                  </div>
                </div>
                { this.state.gridSelected ?
                  areasFullyOperational.length > 0 ?
                    <div className="l-region__content">
                      <Masonry options={this.MASONRY_OPTIONS}>
                        <div className="masonry-sizer" />
                        <div className="gutter-sizer" />

                        {areasFullyOperational.map((area, index) => (
                          <div className="masonry-item" key={index}>
                            <FullyOperationalAreaRow
                              area={area} key={`areaFullyOperational_${index.toString()}`} index={index} deviceClicked = {this.toggleEntityDetailModal}
                              getPrimaryMeasurements={this.getPrimaryMeasurements.bind(this)}
                            />
                          </div>
                        ))}
                      </Masonry>
                    </div> : areasNeededAttention.length > 0 ?
                    <div className={`bottom-text${this.props.isMobile ? ' bottom-text-mobile' : ''}`}> { i18next.t('messages.all-areas-alert') } </div>
                    : null
                  :  <div>
                    <MonitoringDeviceTable
                      datatypeOptions = {this.props.datatypeOptions}
                      statusOptions = {this.props.statusOptions}
                      areaFilterOptions = {this.props.areaFilterOptions}
                      entities = {this.state.entities}
                      grouping = {this.props.grouping}
                      isMobile = {this.props.isMobile}
                    />
                  </div>
                }
              </div>
            ) : null
          }

          <EntityDetailModal
            isMobile={this.props.isMobile}
            entitySerialNumber={this.state.entitySerialNumber}
            show={this.state.showEntityDetailModal}
            onHide={() => { this.toggleEntityDetailModal(null, null, 0) }}
          />

        </div>
      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

class AreaWithAlerts extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      linkTo: null
    }
  }

  render() {
    const { index, area } = this.props;
    const { tag, alerts, entities } = area;
    const tagIconName = tag.icon == null ? 'generic' : tag.icon;

    const totalAlertCount = alerts.map(alert => alert.count).reduce((total, count) => total + count);
    const alertCards = alerts.filter((alert) => {
      if (entities.find((entity) => entity.serialNumber === alert.originatingSerialNumber)) {
        return true;
      } else {
        console.error(`Could not find entity for alert: serial number=${alert.originatingSerialNumber}`);
        return false;
      }
    }).sort((alertA, alertB) => {
      let entityA = entities.find((entity) => entity.serialNumber === alertA.originatingSerialNumber);
      let entityB = entities.find((entity) => entity.serialNumber === alertB.originatingSerialNumber);
      return entityA.displayName.localeCompare(entityB.displayName);
    }).map((alert, i) => {
      let entity = entities.find((entity) => entity.serialNumber === alert.originatingSerialNumber);
      
      const measurements = this.props.getPrimaryMeasurements(entity, area, true);

      const overlay =
        <ActionPopover
          alert={alert}
          {...this.props}
          filterOptions={this.props.filterOptions}
          grouping={this.props.grouping}
          handleViewDetails={this.props.handleViewDetails}
          handleViewTickets={this.props.handleViewTickets}
          updateStatus={this.props.updateStatus}
        />;

      return (
        <div key={`AreaWithAlerts_${index.toString()}_Card_${i.toString()}`}>
          <div className = "icon-with-text">
            <img src={`${config.WEB_BASE_URL}/images/icon/line_category.svg`} className="icon icon--medium" />
            <p className="card-alert__source deviceNameBold" onClick = {this.props.deviceClicked.bind(this, entity.serialNumber, area, alert.count)}>
              {entity.displayName}
            </p>
          </div>

          {measurements}

          <div className="card__header card__noflex">

            <div  className={`card alert-card card--${alert.alertLevel.token === "warning" ? "warning" : (alert.alertLevel.token === "information" ? "information" : "critical")}`}>

              <div className="card__header__top dotIcon">
                <div>
                  <OverlayTrigger trigger="click" rootClose placement="left" overlay={overlay} >
                    <FontAwesomeIcon className = "ellipsisIcon" icon={faEllipsisH} />
                  </OverlayTrigger>
                </div>
              </div>

              <div className="icon-with-text alert-card-icon">
                <img className="icon icon--small thresholdIcon" src={`${config.WEB_BASE_URL}/images/icon/sensor_${alert.thresholdClassification.token}.svg`} alt={alert.thresholdClassification.name} />
                <Link to = {`/monitoring/locations/${this.props.grouping.id}/events?filterByDeviceIds=${entity.entityTypeToken == 'device' ? entity.entityId : ''}&filterByAssetIds=${entity.entityTypeToken == 'asset' ? entity.entityId : ''}`}>
                  <div className="numberCircleInner alert-card-link"> {alert.thresholdClassification.name} ({alert.count}) </div>
                </Link>
              </div>

            </div>
          </div>
        </div>
      );
    });
    
    //
    // Cards that are for devices that aren't in the alert state
    //
    const deviceCards = entities.filter((device) => device.unresolvedEventCount === 0).sort((deviceA, deviceB) => {
      return deviceA.displayName.localeCompare(deviceB.displayName);
    }).map((device, i) => {
      let measurements = this.props.getPrimaryMeasurements(device, area);

      return (
        <div className="alert-line-item" key={`AreaWithAlerts_${index.toString()}_Card_${i.toString()}`}>

          <div className = "icon-with-text">
            <img src={`${config.WEB_BASE_URL}/images/icon/line_category.svg`} className="icon icon--medium" />
            <p className="card-alert__source deviceName" onClick = {this.props.deviceClicked.bind(this, device.serialNumber, area, 0)}>
              {device.displayName}
            </p>
          </div>

          {measurements}

          { i < (entities.length - 1) ?
            null : <div className = "bottomSpacing"> </div>
          }
        </div>
      );
    });

    return (
      <div className="card-region" key={index}>
        <div className="card-region__header alerts__header">
          <div className="icon-with-text">
            <img src={`${config.WEB_BASE_URL}/images/icon/area_${tagIconName}.svg`} className="icon icon--medium" />
            <div className="area-name">
              {tag.name}
            </div>
          </div>
          <Link className = "unresolvedLink" to ={`/monitoring/locations/${this.props.grouping.id}/events?filterByAreaTagIds=${this.props.area.tag.id}`}>
            <div className = "icon-with-text unresolvedIcon">
              <FontAwesomeIcon icon={faExclamationCircle} />
              <div className="tagAlong">{totalAlertCount} { i18next.t('pages.devices.unresolved') }</div>
            </div>
          </Link>
        </div>
        <div className="card-region__cards">
          {alertCards}
          {deviceCards}
        </div>
      </div>
    )
  }
}

const FullyOperationalAreaRow = ({ index, area, getPrimaryMeasurements, deviceClicked }) => {
  const { tag, entities } = area;
  const tagIconName = tag.icon == null ? 'generic' : tag.icon;

  return (
    <div className="card-region bottom-card-region card--simple" key={`FullyOperationalAreaRow_${index}`}>
      <div className="card-region__header alerts__header alerts-bottom">
        <div className="icon-with-text">
          <img src={`${config.WEB_BASE_URL}/images/icon/area_${tagIconName}.svg`} className="icon icon--medium" />
          <div className="area-name">
            {tag.name} ({entities.length})
          </div>
        </div>
      </div>

      {
        entities.sort((deviceA, deviceB) => deviceA.displayName.localeCompare(deviceB.displayName)).map((device, i) => (
          <div className="alert-line-item" key={`AreaWithAlerts_${index.toString()}_Card_${i.toString()}`}>
            <div className = "icon-with-text">
              <img src={`${config.WEB_BASE_URL}/images/icon/line_category.svg`} className="icon icon--medium" />
              <p className="card-alert__source deviceName" onClick = {() => deviceClicked(device.serialNumber, area, 0)}>
                {device.displayName}
              </p>
            </div>

            { getPrimaryMeasurements(device, area) }

            { i < (entities.length - 1) ? null : <div className = "bottomSpacing"> </div> }
          </div>
        ))
      }
    </div>
  );
};


const ActionPopover = ({alert, grouping, filterOptions, handleViewDetails, handleViewTickets, updateStatus, ...props}) => {
  const statusTitle = alert.alertStatus.description;
  const isAutoResolved = alert.alertStatus.token === 'auto_resolved';

  const { localErrorHandler, localSuccessMessage, tagId, groupId, previousGroupingId, underGroupingId, area, index, timezone, ...rest } = props;

  return (
    <Popover id="actions-popover" title={ i18next.t('pages.devices.actions') } {...rest}>
      <ListGroup>
        <ListGroupItem onClick={() => handleViewDetails(grouping.id, alert.alertId)}>{ i18next.t('pages.devices.view-details') } ›</ListGroupItem>
        {alert.ticket != null ?
          <ListGroupItem onClick={() => handleViewTickets(alert.ticket.id)}>{ i18next.t('pages.devices.view-tickets') } ›</ListGroupItem> : null
        }
      </ListGroup>
      <p className="subhead subhead--popover">{ i18next.t('pages.devices.event-status') }</p>
      <ul className="list-unstyled">
        {
          isAutoResolved ? <span>{statusTitle}</span> :
            filterOptions.filter(status => status.token !== 'auto_resolved')
              .map((option, i) => (
                <li key={`ActionPopover_AlertStatus_${i.toString()}`}>
                  <div className="radio">
                    <input type="radio" id={`alert_status_${option.label.toLowerCase()}`} checked={statusTitle === option.label} onChange={() => updateStatus(option, alert.alertId)} />
                    <label htmlFor={`alert_status_${option.label.toLowerCase()}`}>{option.label}</label>
                  </div>
                </li>
              ))
        }
      </ul>
    </Popover>
  )
}

export default MonitoringAlerts;
